import React from "react";
import { Link } from "react-router-dom";

const BannerOne = () => {
  return (
    <section className="banner-area banner-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="banner-img wow fadeInLeft" data-wow-delay=".4s">
              <img alt="banner-image" src="/img/custom-imgs/banner.webp"  />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-content">
              <span className="sub-title wow fadeInUp" data-wow-delay=".2s">
                Amazing <strong>Starts</strong> Here
              </span>
              <h1 className="title wow fadeInUp" data-wow-delay=".4s" style={{marginBottom: "12px"}}>
              Graphic Design <span className="design-style">Agency</span> in Hobart, TAS 
              </h1>
              <p style={{marginBottom: "50px"}}>The Digital Creative Designs, US of digital mastery, where innovation meets creation. </p>
              <Link
                to="/contact"
                className="btn wow fadeInUp"
                data-wow-delay=".6s"
              >
                Contact Us <span></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-shape-wrap">
        <img alt="banner-image" src="/img/banner/banner_shape01.png"  />
        <img alt="banner-image"
          src="/img/banner/banner_shape02.png"
          
          className="animationFramesOne"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape03.png"
          
          className="contactSwimmer"
        />
        <img alt="banner-image" src="/img/banner/banner_shape04.png"  className="rotateme" />
        <img alt="banner-image"
          src="/img/banner/banner_shape05.png"
          
          className="animation1"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape06.png"
          
          className="ribbonRotate"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape07.png"
          
          className="float-bob-x"
        />
      </div>
    </section>
  );
};

export default BannerOne;
